<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('detalhes') }}
                        </h1>   
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            class="save-btn py-0 is-flex is-flex-centered"
                            type="button"
                            @click="save"
                        >
                            {{ $t('salvar') }}
                        </button>
                    </div>
                </div>
                <div class="columns container-critica">
                    <div class="column is-6">
                        <vss-select
                            ref="tipoAutorizacaoSelect"
                            title="tipo-autorizacao"
                            :options="tipoAutorizacaoList"
                            :loading="tipoAutorizacaoLoading"
                            v-model="tipoAutorizacaoSelected"
                            required
                            mlLabels
                            :invalid="isNull(tipoAutorizacaoSelected)"
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            ref="motivoAutorizacaoSelect"
                            title="motivo-autorizacao"
                            :options="motivoAutorizacaoList"
                            :loading="motivoAutorizacaoLoading"
                            v-model="motivoAutorizacaoSelected"
                            :disabled="
                                tipoAutorizacaoSelected &&
                                tipoAutorizacaoSelected.obrigaMotivo === 0
                            "
                            :required="
                                tipoAutorizacaoSelected &&
                                tipoAutorizacaoSelected.obrigaMotivo === 2
                            "
                            :invalid="
                                tipoAutorizacaoSelected &&
                                tipoAutorizacaoSelected.obrigaMotivo === 2 &&
                                isNull(motivoAutorizacaoSelected)"
                        />
                    </div>
                </div>
                <div class="columns container-critica">
                    <div class="column is-12 pb-0 pt-0">
                        <v-textarea
                            ref="motivoAprovacaoObsInput"
                            title="obs-autorizacao"
                            v-model="motivoAprovacaoObs"
                            :required="
                                motivoAutorizacaoSelected &&
                                motivoAutorizacaoSelected.habilitaobrigaobservacao === 2"
                            :disabled="
                                motivoAutorizacaoSelected &&
                                motivoAutorizacaoSelected.habilitaobrigaobservacao === 0"
                            :invalid="
                                motivoAutorizacaoSelected &&
                                motivoAutorizacaoSelected.habilitaobrigaobservacao === 2 &&
                                isNull(motivoAprovacaoObs)"
                            no-clearfix
                        />
                    </div>
                </div>
                <b-table
                    class="data-table itempedido"
                    :data="contagem.data"
                >
                    <b-table-column
                        v-for="(f, i) in contagem.fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.label)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        :numeric="f.numeric"
                        v-slot="props"
                    >
                        <div>
                            {{ props.row[f.key] ? props.row[f.key] : "--" }}
                        </div>
                    </b-table-column>
                </b-table>
                <b-pagination
                    order="is-centered"
                    :total="contagem.totalRows"
                    :current.sync="contagem.currentPage"
                    :per-page="contagem.perPage"
                />
            </div>
        </div>
    </div>
</template>

<script>
import MotivoService from "@/services/agro/MotivoService.js";

export default {
    name: 'DetalhesManage',
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        itensPedidoCritica: Array,
        geralData: Object,
        gradeData: Array,
        hasGrade: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            abaSelecionada: 0,
            abas: null,
            abasAbertas: {},
            motivoService: new MotivoService(this.$http, this.$router),
            contagem: {
                loading: false,
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                column: "produto",
                order: "asc",
                fields: [
                    {
                        key: "codigo",
                        label: "codigo",
                        width: "20%",
                        sortable: true,
                        numeric: false,
                    },
                    { 
                        key: "produto", 
                        label: "produto", 
                        sortable: true 
                    },
                    {
                        key: "critica",
                        label: "critica",
                        width: "50%",
                        sortable: true,
                        numeric: false,
                    },
                ],
                data: []
            },
            tipoAutorizacaoList: [],
            tipoAutorizacaoLoading: false,
            tipoAutorizacaoSelected: null,
            motivoAutorizacaoList: [],
            motivoAutorizacaoLoading: false,
            motivoAutorizacaoSelected: null,
            motivoAprovacaoObs: '',
            isSaving: false
        };
    },
    created() {
        this.preencherDados();
        this.loadTipoAutorizacao();
        this.loadMotivoAutorizacao();
    },
    methods: {
        isItemPedidoAutorizacaoValid() {
            let isValid = true;

            if (this.isNull(this.tipoAutorizacaoSelected)) {
                this.$refs.tipoAutorizacaoSelect.focusedOut = true;
                isValid = false;
            }
    
            if (this.isNull(this.motivoAutorizacaoSelected) && this.$refs.motivoAutorizacaoSelect.required) {
                this.$refs.motivoAutorizacaoSelect.focusedOut = true;
                isValid = false;
            }
            
            if (this.isNull(this.motivoAprovacaoObs) && this.$refs.motivoAprovacaoObsInput.required) {
                this.$refs.motivoAprovacaoObsInput.focusedOut = true;
                isValid = false;
            }

            return isValid;
        },
        loadTipoAutorizacao() {
            this.tipoAutorizacaoLoading = true;

            this.$axios.get('/vendas/pedido/tipo-autorizacao.json')
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[PEDIDO] Erro ${r.status} ao carregar pedido.`
                        );

                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage("error", "pedido-erro");

                        return;
                    } 

                    this.tipoAutorizacaoList = r.data.content
                        .map(({id, descricao: label, obrigaMotivo}) => ({id, label, obrigaMotivo}))
                        .filter(({id}) => id != 0 && id != 1);
                })
                .catch((e) => {
                    console.error("[PEDIDO] Erro ao carregar pedido.", e);
                    this.$root.showMessage("error", "pedido-erro");
                })
                .finally((_) => {
                    this.tipoAutorizacaoLoading = false;
                });
        },
        loadMotivoAutorizacao() {
            this.motivoAutorizacaoLoading = true;
            this.motivoService
                .findAll("motivo", "desc", 0, 10000, 1, [
                    ".*",
                    "ITEM_PEDIDO_AUTORIZACAO",
                ])
                .then((response) => {
                    this.motivoAutorizacaoList = response.content
                        .map(({id, descricao: label, habilitaobrigaobservacao}) => ({id, label, habilitaobrigaobservacao}));

                        if(this.motivoAutorizacaoList.length === 1)
                            this.motivoAutorizacaoSelected = this.motivoAutorizacaoList.at(0);
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.motivoAutorizacaoLoading = false;
                });
        },
        save() {
            this.isSaving = true;

            if(!this.isItemPedidoAutorizacaoValid()) {
                this.$root.showMessage("alert", "msg-campos-obrigatorios");

                return;
            }

            const itensResposta = {
                autorizacaoSituacao: this.tipoAutorizacaoSelected.id,
                idMotivoAprovacao: this.motivoAutorizacaoSelected.id,
                motivoAprovacaoObs: this.motivoAprovacaoObs,
                idsItemPedido: this.itensPedidoCritica.map(({id}) => id)
            }

            this.$axios.post('/vendas/item.json', itensResposta)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[PEDIDO] Erro ${r.status} ao salvar itens.`
                        );

                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage("error", "item-erro");

                        return;
                    }

                    this.$root.showMessage("success", "itens-pedido-salvo-sucesso");

                    this.$emit('refreshList')
                    this.$emit('voltar', true)
                })
                .catch((e) => {
                    console.error(`[PEDIDO] Erro ${r.status} ao salvar itens.`, e);
                    this.$root.showMessage("error", "item-erro");
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
        preencherDados(){
            this.contagem.data = this.itensPedidoCritica;
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px 20px;
    height: 100%;

    .page {
        position: relative;

        .listing-header {
            padding-bottom: 20px;
        }

        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }
        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }

    @media only screen and (max-width: 760px) {
        .nav.nav-tabs-main {
            display: flex;
            justify-content: center;
            padding: 0;
            margin: 0;

            &::after {
                display: none;
            }
        }

        .nav.nav-tabs.nav-tabs-children {
            display: none;
        }
    }

    @media only screen and (min-width: 761px) {
        .mobile-tab-list {
            display: none;
        }
    }
}

.save-btn {
    min-width: 100px;
    height: 43px;
}
</style>
